import React, { useState } from 'react'

type Props = {
  src: string
  alt: string
  placeholder?: string
  width?: number
  height?: number
  customStyle?: React.CSSProperties | undefined
}

const SmartImage = (props: Props) => {
  const { alt, src, placeholder, customStyle, width, height } = props
  const [loaded, setLoaded] = useState(false)
  const [error, setError] = useState(false)

  const boxWidth = width ?? (typeof customStyle?.width === 'number' ? customStyle.width : undefined)
  const boxHeight =
    height ?? (typeof customStyle?.height === 'number' ? customStyle.height : undefined)

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: boxWidth,
        height: boxHeight,
        minWidth: boxWidth,
        minHeight: boxHeight,
        position: 'relative',
        overflow: 'hidden',
        flexShrink: 0,
      }}
    >
      {!loaded && !error && placeholder && (
        <span
          aria-hidden
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 12,
            opacity: 0.5,
          }}
        >
          {placeholder}
        </span>
      )}
      {!error && (
        <img
          src={src}
          alt={alt}
          width={boxWidth}
          height={boxHeight}
          onLoad={() => setLoaded(true)}
          onError={() => setError(true)}
          style={{
            ...customStyle,
            width: boxWidth ?? customStyle?.width,
            height: boxHeight ?? customStyle?.height,
            opacity: loaded ? 1 : 0,
            display: 'block',
          }}
        />
      )}
    </span>
  )
}

export default SmartImage
